var _rect, _mask, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutPic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2055,
    height: 1245,
    viewBox: "0 0 2055 1245",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2055,
    height: 1245,
    fill: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 2055,
    height: 1245
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2055,
    height: 1245,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.52,
    x: 1,
    y: 308,
    width: 660,
    height: 440,
    rx: 6.8,
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.52,
    x: 1320,
    y: 320.642,
    width: 660,
    height: 440,
    rx: 6.8,
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.52,
    x: 707.92,
    y: 638.711,
    width: 660,
    height: 440,
    rx: 6.8,
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1218.23 311.24C1231.69 303.941 1243.78 297.455 1257.42 295.742V295.742C1271.86 293.887 1285.97 297.776 1298.9 304.356V304.356C1309.93 309.939 1320.99 317.853 1327.71 328.495V328.495C1337.36 343.791 1333.5 358.025 1330 374.678V374.678C1328.07 383.749 1326.16 393.098 1327.9 402.221V402.221C1328.13 403.399 1328.46 404.633 1329.27 405.477V405.477C1331.79 408.22 1336.21 405.64 1338.95 403.119V403.119C1347.03 395.794 1355.2 386.024 1365.87 382.654V382.654C1376.43 379.317 1390.09 383.344 1397.12 391.946V391.946C1402.4 398.405 1403.29 406.899 1401.61 414.926V414.926C1400.38 420.793 1397.78 426.442 1394.52 430.973V430.973C1390.53 436.486 1385.28 440.945 1380.62 445.836V445.836C1373.08 453.696 1347.57 472.638 1342.73 508.611V508.611L1342.77 508.602C1377.21 516.62 1405.65 497.213 1437.74 476.965V476.965C1468.1 457.808 1501.71 437.896 1546.75 439.752V439.752C1591.88 441.628 1614.54 416.642 1638.37 391.387V391.387C1663.47 364.782 1689.88 337.877 1745.23 341.751V341.751C1853.15 349.35 1948.5 299.339 1951.02 211.355V211.355C1953.49 123.387 1876.05 33.1349 1804.06 31.1159V31.1159C1768.23 30.0864 1722.44 64.514 1676.11 99.0678V99.0678C1629.43 133.885 1582.21 168.827 1544.09 167.739V167.739C1468.11 165.616 1447.21 56.9722 1359.24 54.4582V54.4582C1351.26 54.2305 1343.28 55.0749 1335.4 56.8961V56.8961C1256.25 75.1675 1186.09 191.804 1218.23 311.24",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1288.72 1041.5C1277.64 1053.3 1268.72 1067.47 1265.17 1083.23V1083.23C1259.41 1109.27 1269.15 1136.91 1285.62 1157.9V1157.9C1306.86 1185.02 1335.86 1204.64 1368.7 1214.79V1214.79C1432.47 1234.6 1512.16 1223.75 1571 1193.42V1193.42C1625.84 1165.12 1671.73 1109.24 1655.38 1044.46V1044.46C1654.38 1040.5 1653.13 1036.52 1651.61 1032.6V1032.6C1642.88 1009.54 1625.54 988.292 1599.2 987.111V987.111C1576.22 986.09 1557.93 999.713 1539.18 1011.84V1011.84C1531.01 1017.18 1522.73 1022.21 1513.95 1025.63V1025.63C1502.44 1030.14 1492.69 1029.51 1482.62 1026.46V1026.46C1457.62 1018.97 1430.53 996.778 1368.7 1001.77V1001.77C1363.23 1002.21 1357.8 1003.06 1352.46 1004.3V1004.3C1328.26 1009.89 1305.75 1023.28 1288.72 1041.5M1454.55 1097.43C1445.42 1097.9 1434.42 1099.17 1426.29 1094.19V1094.19C1424.81 1093.3 1423.41 1092.18 1422.57 1090.69V1090.69C1421.05 1087.84 1422.01 1084.17 1424.06 1081.69V1081.69C1429.51 1075.05 1439.61 1073.09 1447.36 1070.73V1070.73C1455.59 1068.17 1464.05 1065.72 1471.11 1060.52V1060.52C1478.26 1055.22 1485.82 1049.74 1494.73 1047.8V1047.8C1516.29 1043.03 1525.92 1063.22 1504.28 1082.96V1082.96C1497.84 1088.84 1489.41 1092.26 1480.53 1094.31V1094.31C1471.83 1096.32 1462.69 1097.02 1454.55 1097.43",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1344.87 757.445C1374.72 777.235 1413.02 800.498 1436.55 810.331V810.331C1440.33 811.927 1443.73 813.152 1446.67 813.953V813.953L1482.62 1026.46C1492.69 1029.51 1502.44 1030.14 1513.95 1025.63V1025.63C1522.73 1022.21 1531.01 1017.18 1539.18 1011.84V1011.84C1557.79 826.957 1550.1 781.863 1550.1 781.863V781.863C1550.1 781.863 1504.61 736.495 1455.16 689.656V689.656C1447.55 684.598 1438.08 683.773 1427.76 686.155V686.155C1399.35 692.717 1364.57 723.596 1344.87 757.445",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1210.69 318.782C1198.79 331.627 1188.29 347.311 1179.23 364.263C1168.26 382.63 1156.11 417.426 1156.11 417.426C1146.29 445.431 1139.74 472.892 1136.29 494.254L1136.26 494.298C1132.74 532.555 1153.84 535.606 1187.47 536.175C1221.07 536.789 1286.03 524.548 1331.9 512.191C1335.69 511.153 1339.23 509.966 1342.73 508.584C1347.56 472.615 1373.08 453.669 1380.61 445.812C1385.28 440.914 1390.53 436.462 1394.51 430.945C1397.77 426.415 1400.37 420.766 1401.6 414.899C1403.28 406.875 1402.39 398.378 1397.12 391.918C1390.08 383.32 1376.43 379.289 1365.87 382.63C1355.19 385.997 1347.02 395.763 1338.94 403.092C1336.2 405.613 1331.78 408.192 1329.26 405.449C1328.45 404.61 1328.13 403.372 1327.89 402.193C1326.16 393.07 1328.06 383.722 1330 374.651C1333.49 358.001 1337.35 343.768 1327.7 328.467C1320.98 317.826 1309.92 309.912 1298.9 304.328C1285.96 297.749 1271.85 293.864 1257.42 295.719C1255.37 295.978 1253.35 296.341 1251.36 296.801C1240.11 299.398 1229.66 305.013 1218.22 311.213C1215.65 313.613 1213.16 316.158 1210.69 318.782Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1308.5 378.17C1300.78 402.819 1276.24 426.51 1253.08 422.513C1230.99 418.709 1221.21 398.285 1233.5 377.237C1259.23 365.311 1283.63 367.768 1308.5 378.17ZM1159.9 360.761C1150.17 381.217 1151.66 405.107 1170.05 408.25C1189.28 411.531 1211.96 396.948 1216.93 375.262C1203.89 359.249 1183.48 356.794 1159.88 360.69L1159.9 360.761Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M860.072 645.552C858.114 665.504 863.221 682.839 876.413 691.083V691.083L933.677 690.178L934.574 690.505C928.016 708.153 922.769 729.151 922.14 751.341V751.341C899.732 783.198 758.303 864.086 703.664 880.806V880.806C812.344 853.662 968.27 1011.96 961.774 1084.65V1084.65C960.973 1093.45 958.66 1100.68 955.172 1106.53V1106.53C1026.55 1023.1 1163.27 834.51 1300.57 771.325V771.325C1312.75 788.506 1324.98 807.152 1331.24 820.772V820.772C1325.77 802.208 1332.2 779.211 1344.87 757.445V757.445C1371.73 711.299 1426.6 670.675 1455.16 689.656V689.656C1413.76 650.44 1369.53 610.162 1347 594.755V594.755C1339.16 589.421 1332.84 584.271 1327.89 579.339V579.339C1044.96 708.288 995.363 676.594 1145.35 565.199V565.199C1132.41 568.022 1120.71 566.782 1113.79 566.492V566.492L942.059 548.666C893.457 559.886 863.833 607.449 860.072 645.552",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1471.11 1060.52C1464.05 1065.72 1455.59 1068.17 1447.36 1070.73V1070.73C1439.61 1073.09 1429.51 1075.05 1424.06 1081.69V1081.69C1422.01 1084.17 1421.05 1087.84 1422.57 1090.69V1090.69C1423.41 1092.18 1424.81 1093.3 1426.29 1094.19V1094.19C1434.42 1099.17 1445.42 1097.9 1454.55 1097.43V1097.43C1471.02 1096.59 1491.53 1094.6 1504.28 1082.96V1082.96C1525.92 1063.22 1516.29 1043.03 1494.73 1047.8V1047.8C1494.59 1047.83 1494.45 1047.86 1494.31 1047.9V1047.9C1485.58 1049.91 1478.15 1055.3 1471.11 1060.52",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1330.24 820.772L1330.26 820.85C1331.55 823.55 1332.52 826.035 1333.25 828.288V828.288C1356.67 873.54 1414.11 829.28 1435.54 810.421V810.421L1435.55 810.331C1412.02 800.498 1373.72 777.235 1343.87 757.445V757.445C1331.2 779.211 1324.77 802.208 1330.24 820.772",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1144.35 565.199C994.363 676.594 1043.96 708.288 1326.89 579.339V579.339C1300.22 553.105 1310.95 532.156 1331.9 510.195V510.195C1286.03 522.556 1221.08 534.8 1187.48 534.183V534.183C1174.72 553.96 1158.73 562.044 1144.35 565.199",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1144.35 565.199C994.363 676.594 1043.96 708.288 1326.89 579.339V579.339C1300.22 553.105 1310.95 532.156 1331.9 510.195V510.195C1286.03 522.556 1221.08 534.8 1187.48 534.183V534.183C1174.72 553.96 1158.73 562.044 1144.35 565.199",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M956.172 1105.53C959.66 1099.68 961.973 1092.45 962.774 1083.65V1083.65C962.774 1083.65 909.222 1094.94 836.043 1110.48V1110.48C843.976 1119.78 930.841 1148.04 956.172 1105.53",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M594.18 306.046C593.811 308.023 594.759 309.976 595.879 311.61V311.61C596.006 311.823 596.178 312.034 596.343 312.197V312.197C589.151 318.048 585.276 324.896 583.95 331.971V331.971L609.277 322.183C610.719 322.917 612.213 323.521 613.697 324.077V324.077C616.144 325.077 618.612 325.985 621.049 326.941V326.941C621.628 327.136 622.167 327.336 622.667 327.548V327.548C624.156 328.112 625.606 328.717 627.026 329.338V329.338C628.071 329.794 629.371 330.27 630.807 330.801V330.801L584.906 346.94C588.322 358.553 597.728 369.227 609.841 375.302V375.302C623.708 382.199 639.463 383.94 653.614 390.11V390.11C672.33 398.274 678.794 410.981 685.76 429.242V429.242L756.474 613.374C756.474 613.374 800.878 641.055 860.074 646.56V646.56C863.843 608.455 893.459 560.894 942.061 549.674V549.674C942.061 549.674 853.765 544.729 817.512 549.691V549.691C800.161 487.32 735.151 392.1 703.779 336.943V336.943C693.663 319.085 672.979 310.063 653.222 305.018V305.018C643.191 302.448 632.855 301.263 622.499 301.232V301.232C619.153 301.232 607.274 300.724 599.99 302.405V302.405C596.833 303.134 594.539 304.275 594.18 306.046",
    fill: "#9EA0A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M583.156 332.153L605.84 323.239C601.291 321.347 597.307 318.317 594.272 314.44C588.544 318.808 584.594 325.101 583.156 332.153ZM647.046 342.219C650.582 346.963 664.176 365.207 678.187 373.629C689.632 390.508 674.399 419.098 674.399 419.098C668.297 402.713 662.33 391.223 645.581 384.061C639.709 381.504 633.536 379.796 627.362 378.087C620.195 376.104 613.027 374.12 606.329 370.808C595.747 365.71 587.684 356.552 583.973 345.419L625.146 330.951C626.138 331.31 627.207 331.681 628.323 332.069C635.158 334.442 643.716 337.415 646.718 341.779C646.815 341.909 646.925 342.056 647.046 342.219Z",
    fill: "url(#paint12_linear)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M449.399 388.241C481.95 391.071 502.264 392.091 506.185 374.597V374.597L505.316 374.921C502.279 375.992 499.004 374.449 497.907 371.459V371.459C497.819 371.237 497.765 371.003 497.701 370.726V370.726C497.062 367.959 498.527 365.076 501.277 363.989V363.989L501.42 363.915C497.503 362.398 493.062 362.421 488.405 363.496V363.496C474.526 366.701 458.758 379.257 449.399 388.241",
    fill: "url(#paint13_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M650.618 960.797C604.842 978.919 530.72 1017.58 469.091 1051.15V1051.15C433.456 1070.54 401.997 1088.23 382.612 1099.24V1099.24C369.837 1106.49 362.297 1110.82 362.297 1110.82V1110.82L263.841 1263.69L159.27 1425.97L164.562 1429.35L164.601 1429.34L218.903 1463.97L218.942 1463.96L224.486 1467.53C280.527 1402.82 329.086 1363.32 365.646 1328.57V1328.57C407.358 1288.93 433.436 1255.53 437.163 1197.89V1197.89C467.943 1190.21 576.782 1166.6 687.456 1142.94V1142.94C738.819 1131.95 790.541 1120.9 835.044 1111.49V1111.49C908.224 1095.95 961.776 1084.66 961.776 1084.66V1084.66C965.958 1038.04 903.249 956.173 829.062 910.609V910.609C818.42 912.824 807.223 915.269 795.624 917.947V917.947C750.101 928.457 698.464 942.587 650.618 960.797",
    fill: "url(#paint14_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.867 965.83L47.9788 1039.69L-81.594 1125.19L-79.3091 1129.22L-47.8476 1184.23L-45.1659 1188.91C2.36387 1161.84 55.0641 1143.64 104.349 1125.24V1125.24C155.84 1106.09 203.623 1086.72 237.958 1056.91V1056.91C251.916 1044.82 263.699 1030.94 272.547 1014.69V1014.69L344.884 1028.04L470.091 1051.15C531.72 1017.58 605.842 978.919 651.618 960.797V960.797C711.657 937.945 777.615 921.531 830.027 910.617V910.617C788.596 885.165 743.596 871.087 704.666 880.814V880.814C683.673 876.304 570.458 880.762 463.875 886.239V886.239C415.917 888.69 369.332 891.398 333.048 893.576V893.576C290.939 896.077 262.821 897.884 262.821 897.884V897.884L159.867 965.83Z",
    fill: "url(#paint15_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M501.277 363.989C498.527 365.076 497.062 367.959 497.701 370.726V370.726C497.765 371.003 497.819 371.237 497.907 371.459V371.459C499.004 374.449 502.279 375.992 505.316 374.921V374.921L630.807 330.801C629.371 330.27 628.071 329.794 627.025 329.338V329.338C621.39 326.817 615.041 324.921 609.277 322.183V322.183L501.277 363.989Z",
    fill: "#9EA0A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M771.552 259.394L653.484 305.085C661.867 307.254 670.459 310.152 678.267 314.101V314.101L778.701 278.803C783.753 277.017 786.523 271.784 785.361 266.752V266.752C785.262 266.323 785.124 265.904 784.983 265.489V265.489C783.166 260.535 777.944 257.812 772.935 258.968V258.968C772.472 259.075 772.008 259.219 771.552 259.394",
    fill: "#9EA0A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1568.43 1060.28C1568.43 1063.78 1568.97 1067.37 1570.74 1070.38C1574.83 1077.32 1584.14 1079.14 1592.16 1078.37C1600.03 1077.63 1608.02 1074.88 1613.4 1069.09C1639.41 1041.09 1568.33 1017.39 1568.43 1060.28M1551.75 1154.78C1556.78 1158.57 1563.35 1159.99 1569.64 1159.55C1573.12 1159.32 1576.6 1158.48 1579.81 1157.09C1584.78 1154.94 1589.12 1151.46 1591.85 1146.82C1596.36 1139.16 1595.6 1128.36 1589.08 1122.33C1566.25 1101.2 1523.71 1133.68 1551.75 1154.78M1454.24 1187.14C1459.18 1192.73 1467.25 1194.46 1474.72 1194.32C1480.59 1194.2 1486.57 1193.08 1491.64 1190.11C1510.57 1179.01 1499.76 1145.66 1478.82 1144.87C1460.53 1144.17 1440.51 1171.61 1454.24 1187.14M1358.03 1175.51C1363.19 1178.85 1369.64 1179.8 1375.68 1178.6C1379.21 1177.89 1382.6 1176.45 1385.5 1174.33C1393.36 1168.57 1397.5 1158.37 1396.58 1148.67C1392.16 1102.18 1316.89 1148.87 1358.03 1175.51M1361.24 1082.16C1359.76 1086.76 1356.52 1090.62 1352.77 1093.65C1349.65 1096.17 1346.09 1098.21 1342.29 1099.48C1339.73 1100.34 1337.07 1100.84 1334.37 1100.92C1327.66 1101.12 1320.76 1098.47 1316.48 1093.3C1284.66 1054.92 1375.57 1037.73 1361.24 1082.16",
    fill: "url(#paint16_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 1,
    y1: 748,
    x2: 661,
    y2: 748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#494949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 1320,
    y1: 760.642,
    x2: 1980,
    y2: 760.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#494949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 707.92,
    y1: 1078.71,
    x2: 1367.92,
    y2: 1078.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#494949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 1269.27,
    y1: 533.004,
    x2: 1991.87,
    y2: 366.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#494949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 1631.27,
    y1: 939.927,
    x2: 1245.32,
    y2: 1029.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6C6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 1373.36,
    y1: 727.437,
    x2: 1373.79,
    y2: 1027.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EA0A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A7A7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 1335.93,
    y1: 553.799,
    x2: 1493.9,
    y2: 300.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EA0A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57585C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 1297.15,
    y1: 329,
    x2: 1148,
    y2: 363.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EA0A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCFD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 765.867,
    y1: 1150.24,
    x2: 1521.23,
    y2: 975.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 1434.45,
    y1: 1065.17,
    x2: 1440.81,
    y2: 1101.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EA0A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A7A7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 1258.93,
    y1: 589.932,
    x2: 1259.57,
    y2: 515.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A6AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#717278"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 843.999,
    y1: 1144.95,
    x2: 970.199,
    y2: 1115.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 594.234,
    y1: 249.597,
    x2: 566.313,
    y2: 355.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 502.853,
    y1: 360.161,
    x2: 445.949,
    y2: 373.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#565656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A7A7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 386.96,
    y1: 1076.9,
    x2: 453.793,
    y2: 1340.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EA0A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57585C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: -535.145,
    y1: 1295.54,
    x2: -312.255,
    y2: 1710.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EA0A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57585C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 1343.41,
    y1: 1225.62,
    x2: 1642.54,
    y2: 1156.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484848"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutPic);
export default __webpack_public_path__ + "static/media/about-pic.236c54e0fe4d2b680daffa2fefa434fe.svg";
export { ForwardRef as ReactComponent };